/**
 * 课程详情
 * @param weekTimeId
 * @param path
 */
import { CourseItem, toNumber } from "./service";

export function courseDetailUrl(weekTimeId: number, path: string = "chapter") {
    return `/course/detail/${weekTimeId}/${path}`;
}

export function courseDetailUrlNoWeekId(course: CourseItem, url: string) {
    return `/course/detail/${course.weekTimeId}/${course.batchNo}/${course.courseNo}/${course.courseSeq}${url}`;
}

/**
 * 投屏页面
 * @param weekTimeId
 * @param path
 */
export function courseProjectionUrl(
    weekTimeId: number,
    path: string = "chapter"
) {
    return `/course/projection/${weekTimeId}/${path}`;
}

/**
 * 学员/成绩列表
 * @param courseNo
 * @param courseSeq
 * @param weekTimeId
 * @param tab
 */
export function studentListUrl({
    courseSeq,
    courseNo,
    tab = "class"
}: {
    courseNo: string;
    courseSeq: string;
    tab?: string;
}) {
    return `/classes/${courseNo}/${courseSeq}/${tab}`;
}

/**
 * 留作业页面
 * @param courseSeq
 * @param courseNo
 * @param weekTimeId
 * @param week
 * @param continunity
 * @param section
 * @param weekTime
 */
export function homeworkEditUrl({
    courseSeq,
    courseNo,
    weekTimeId,
    week,
    continunity,
    section,
    weekTime
}: {
    courseNo: string;
    courseSeq: string;
    weekTime: string;
    week: string;
    section: string;
    continunity: string;
    weekTimeId: number;
}) {
    return `/homework/edit/${courseNo}/${courseSeq}/${weekTime}/${
        toNumber(week) - 1
    }/${section}/${continunity}/${weekTimeId}`;
}

/**
 * 留作业页面
 * @param courseSeq
 * @param courseNo
 * @param weekTimeId
 * @param week
 * @param continunity
 * @param section
 * @param weekTime
 */
export function homeworkReviewUrl({
    courseSeq,
    courseNo,
    weekTimeId,
    week,
    continunity,
    section,
    weekTime
}: {
    courseNo: string;
    courseSeq: string;
    weekTime: string;
    week: string;
    section: string;
    continunity: string;
    weekTimeId: number;
}) {
    return `/homework/review/list/${courseNo}/${courseSeq}/${weekTime}/${
        toNumber(week) - 1
    }/${section}/${continunity}/${weekTimeId}`;
}
